var i = Object.defineProperty;
var n = (t, e, s) => e in t ? i(t, e, { enumerable: !0, configurable: !0, writable: !0, value: s }) : t[e] = s;
var o = (t, e, s) => n(t, typeof e != "symbol" ? e + "" : e, s);
import { HttpClient as r, httpClient as p } from "../../httpClient.js";
class a extends r {
  constructor() {
    super(...arguments);
    o(this, "endpoint", "/course-categories");
  }
  async getAll() {
    return p.get(this.endpoint);
  }
}
const g = new a();
export {
  g as default
};
